import { UploadedFile } from 'models/general'
import {
  IAccountingFileStatus,
  TAccountingFileTypes,
} from 'models/accounting.models'
import { formatDate, formatName } from 'lib/utils/Accounting/accounting.utils'
import { useAccountingContext } from 'containers/Accounting/AccountingContainer/AccountingContainer'
import { FileCardAlt } from 'components/Shared/FileCard/FileCard'
import FileUploader from 'components/FormComponents/FileUploader/FileUploader'
import AccountingFileDropzoneContentMultiple from '../AccountingFileDropzoneContentMultiple/AccountingFileDropzoneContentMultiple'
import { useAccountingStepFiveContext } from '../AccountingStepFive/AccountingStepFive'
import { ISydDocument } from 'models/shared.models'
import './styles.scss'

export interface IAccountingFileDropzoneMultipleProps<TState> {
  disabled: boolean
  label: string
  totalUploadItems: ISydDocument[]
  uploadedFiles: ISydDocument[]
  additionalInvalidFiles?: ISydDocument[]
  additionalValidFiles?: ISydDocument[]
  className?: string
  fileStatuses?: IAccountingFileStatus[]
  fileStatusesKey?: keyof TState
  filesToValidate?: ISydDocument[]
  fileType?: TAccountingFileTypes
  openCommentsDialogKey?: keyof TState
  uploadedAndValidatedFiles?: ISydDocument[]
  uploadingFile?: UploadedFile
  updateState: (update: (draft: TState) => void) => void
}

const AccountingFileDropzoneMultiple = <TState,>({
  additionalInvalidFiles,
  additionalValidFiles,
  className,
  disabled,
  fileStatuses,
  fileStatusesKey,
  filesToValidate,
  fileType,
  label,
  openCommentsDialogKey,
  totalUploadItems,
  uploadedAndValidatedFiles,
  uploadedFiles,
  uploadingFile,
  updateState,
}: IAccountingFileDropzoneMultipleProps<TState>) => {
  const { handleFileRetryUpload } = useAccountingContext()

  const { fileUploadHandler } = useAccountingStepFiveContext()

  return (
    <article
      className={`accounting-file-dropzone-multiple-component ${className ?? ''}`}>
      <p>{label}</p>
      <div className="initial-upload">
        <FileUploader
          className="file-zone"
          color="secondary"
          label="Subir archivo"
          onValue={fileUploadHandler(
            totalUploadItems,
            additionalValidFiles,
            additionalInvalidFiles
          )}
          type={fileType}
          disabled={disabled}
        />
        {!!uploadingFile && (
          <FileCardAlt
            title={formatName(uploadingFile)}
            subtitle={formatDate()}
            type={'File'}
            actions={[
              {
                label: 'Reintentar',
                action: () => handleFileRetryUpload(uploadingFile),
              },
            ]}
            error={uploadingFile.error}
            loading={uploadingFile.activity}
            className="file-zone"
          />
        )}
      </div>

      <div className="upload-items">
        {totalUploadItems.length > 0 &&
          totalUploadItems.map(({ idWsfile }) => (
            <AccountingFileDropzoneContentMultiple<TState>
              key={`accounting-file-dropzone-content-${idWsfile}`}
              fileStatuses={fileStatuses}
              fileStatusesKey={fileStatusesKey}
              filesToValidate={filesToValidate}
              openCommentsDialogKey={openCommentsDialogKey}
              uploadedAndValidatedFiles={uploadedAndValidatedFiles}
              uploadedFiles={uploadedFiles}
              uploadItemId={idWsfile}
              updateState={updateState}
            />
          ))}
      </div>
    </article>
  )
}

export default AccountingFileDropzoneMultiple
